import { Factory } from '@octopus-do/octopus-project-core'

import { InitialColorIds } from '../colors'
import { InitialTabId } from '../tabs'
import { InitialSectionIds } from './InitialSectionIds'

export const MainSection = Factory.section({
  id: InitialSectionIds.main,
  title: 'Main',
  tabId: InitialTabId,
  colorId: InitialColorIds.cloudy,
  order: 0,
  textSize: 's',
})

export const initialSections = [
  MainSection,
  Factory.section({
    id: InitialSectionIds.secondary,
    title: 'Section',
    tabId: InitialTabId,
    colorId: InitialColorIds.cloudy,
    order: 1,
    textSize: 's',
  }),
]
